<template>
  <fragment>
    <div
      v-if="hasLogin"
      class="webapp-layout-mainHeader navbar navbar-light py-0"
      :class="extraClasses"
    >
      <div class="d-flex align-items-center wayFind-bar">
        <a
          class="btn btn-link d-lg-none pl-0 mr-3 text-secondary"
          @click.prevent="toggle()"
        >
          <i class="pz-icon icon-menu"></i>
        </a>

        <span class="f-20 mr-2 d-none d-lg-inline-block">👏</span>
        <span class="d-none d-md-inline-block text-black-80"
          >欢迎来到品职课堂!</span
        >
        <!-- 今天是您与品职一起走过的{{ userInfo.totalDays }}天！ -->
      </div>
      <ToolBar />
    </div>
    <div
      v-else
      class="
        webapp-layout-mainHeader
        navbar navbar-dark
        bg-danger
        text-white text-center
      "
    >
      <div>
        <a
          class="btn btn-link d-lg-none pl-0 mr-3 text-white"
          id="WayFindBar-toggle"
          @click.prevent="toggle()"
        >
          <i class="pz-icon icon-menu"></i>
        </a>
        <span class="d-none d-md-inline-block"
          >您好！亲爱的学员，您当前处于未登录状态，我们无法保存您的学习记录!</span
        >
      </div>
      <a
        class="text-white-80"
        id="WayFindBar-go2Login"
        href="javascript:undefined"
        @click.prevent="go2Login"
        >登录｜注册</a
      >
    </div>
  </fragment>
</template>
<script>
import { /* mapActions, */ mapGetters } from 'vuex';
import { /* LANDING_PAGE, */ LOGIN_PAGE } from '../constants/routes';
import $ from 'jquery';
// import { PORTAL_URLS } from '../constants';

import ToolBar from './ToolBar.vue';

export default {
  name: 'WayFindBar',
  props: {
    extraClasses: String,
  },

  components: {
    ToolBar,
  },

  data: () => {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),

    hasLogin() {
      return !this.userInfo.unLogin;
    },

    avatar() {
      return this.userInfo.avatar;
    },

    nickName() {
      return this.userInfo.nickname;
    },

    bonusPoint() {
      return this.userInfo.bonusPoint;
    },

    hasNewMessages() {
      return this.userInfo.hasNewMessages;
    },
  },

  methods: {
    go2Login() {
      // console.log(this.$route.path);
      this.$router.push(`${LOGIN_PAGE}?login_redirect_uri=${this.$route.path}`);
    },

    toggle() {
      if (!$(`body`).hasClass('is-open')) {
        $(`body`).addClass('is-open');
      } else {
        $(`body`).removeClass('is-open');
      }
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped type="text/css">
.course .wayFind-bar,
.course .wayFind-bar .text-secondary,
.course .wayFind-bar .text-orange,
.free-course .wayFind-bar,
.free-course .wayFind-bar .text-secondary,
.mini-course .wayFind-bar,
.mini-course .wayFind-bar .text-secondary {
  color: rgba(255, 255, 255, 0.8) !important;
}
</style>
